import { createTheme } from '@mui/material/styles';

const colors = {
  white: '#FFFFFF',
  grisInput: '#888076',
  pink: '#FFF0DE',
  grisSemiClair: '#EEE9E0',
  marronSemiClair: '#7C7570',
  bleuClairTunnel: '#E5F5FF',
  vertDigidom: '#0eb50e',
  vert: '#00C397',
  orange: '#FFB62D',
  gris: '#777A8E',
  violet: '#3C345A',
  vertUnPeuClaire: '#00C794',
  bleuClaire: '#E1F1F7',
  grisTunnel: '#777A90',
  red: '#ff0000',
  bleu: '#8adbf9',
};

export const themeBV = createTheme({
  palette: {
    primary: {
      main: '#FF9D00',
    },
    secondary: { main: '#FF9D00', light: '#FBB131' },
  },
  colors,
  components: {
    MuiInputLabel: {
      styleOverrides: {
        root: {
          '&.Mui-focused': {
            color: '#FF9D00',
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: '8px !important',
        },
      },
    },
  },
});

export const themeTunnel = createTheme({
  palette: {
    primary: {
      main: '#E1F1F7',
    },
    secondary: { main: '#E1F1F7' },
  },
  colors,
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: '8px !important',
        },
      },
    },
  },
});

export const previewDocThemeBV = createTheme({
  palette: {
    primary: {
      main: '#FF9D00',
    },
    secondary: { main: '#ffe4c4' },
  },
  colors,
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: '8px !important',
        },
      },
    },
  },
});

export const previewDocThemeTunnel = createTheme({
  palette: {
    primary: {
      main: '#00C397',
    },
    secondary: { main: '#E5F5FF' },
  },
  colors: {
    ...colors,
    vert: '#00C397',
    bleuClaire: '#8adbf9',
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: '8px !important',
        },
      },
    },
  },
});
